<mat-toolbar color="accent">Edit Campaign Entry Settings</mat-toolbar>

<mat-dialog-content class="!text-black">
  <pr-campaign-entry-settings
    [campaign]="data.campaign"
    (formChange)="formData.set($event)"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="submit()">Save</button>
</mat-dialog-actions>
